import React from 'react'
import { ModalWindowBody } from './components/modal-window-body'
import { ModalWindowContainer } from './components/modal-window-container'
import { ModalWindowFooter } from './components/modal-window-footer'
import { ModalWindowHeader } from './components/modal-window-header'
import { CommonModalWindowProps, ModalWindowSizeEnum } from './types'

export const ModalWindow = ({
  isOpened = false,
  children,
  onClose,
  width = 700,
  size = ModalWindowSizeEnum.Medium,
  title,
  cancelButtonProps,
  confirmButtonProps,
  hideHeader = false,
}: CommonModalWindowProps) => {
  return (
    <ModalWindowContainer isOpened={isOpened} onClose={onClose} width={width}>
      <ModalWindowHeader size={size} onClose={onClose} hideHeader={hideHeader}>
        {title}
      </ModalWindowHeader>
      <ModalWindowBody size={size}>{children}</ModalWindowBody>
      <ModalWindowFooter
        size={size}
        cancelButtonProps={cancelButtonProps}
        confirmButtonProps={confirmButtonProps}
      />
    </ModalWindowContainer>
  )
}
